import React, { useState } from 'react';
import Button from './Button';

export type ListingImageOrderItem =
  | { type: 'existing'; id: string; src: string; url: string }
  | { type: 'new'; id: string; src: string };

export interface ListingImageOrderGridProps {
  items: ListingImageOrderItem[];
  onRemove: (id: string) => void;
  onReorder: (fromIndex: number, toIndex: number) => void;
  title?: string;
}

const ListingImageOrderGrid: React.FC<ListingImageOrderGridProps> = ({
  items,
  onRemove,
  onReorder,
  title = 'İlan Resimleri',
}) => {
  const [dragIndex, setDragIndex] = useState<number | null>(null);

  if (items.length === 0) return null;

  const handleDrop = (toIndex: number) => {
    if (dragIndex == null || dragIndex === toIndex) return;
    onReorder(dragIndex, toIndex);
    setDragIndex(null);
  };

  return (
    <div className="mb-3">
      <h5 className="card-title mb-3 fw-bold">
        <i className="fas fa-images me-2 text-primary" aria-hidden="true" />
        {title}
      </h5>
      {items.length > 1 && (
        <p className="text-muted small mb-2">Sıralamak için görselleri sürükleyip bırakın.</p>
      )}
      <div className="d-flex flex-wrap gap-3">
        {items.map((item, index) => (
          <div
            key={item.id}
            className="position-relative rounded overflow-hidden border bg-light"
            style={{ width: 120, height: 120, cursor: 'grab' }}
            draggable
            onDragStart={() => setDragIndex(index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => handleDrop(index)}
          >
            {index === 0 && (
              <span className="badge bg-primary position-absolute top-0 start-0 m-1" style={{ zIndex: 2 }}>
                Kapak
              </span>
            )}
            <img
              src={item.src}
              alt={`İlan fotoğrafı ${index + 1}`}
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
              draggable={false}
              loading="lazy"
            />
            <Button
              type="button"
              className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0 d-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28, zIndex: 2 }}
              onClick={() => onRemove(item.id)}
              aria-label="Fotoğrafı kaldır"
            >
              <i className="fas fa-times" aria-hidden="true" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListingImageOrderGrid;
